import { AuthTypes } from 'state/types';

export const setUserProfile = payload => dispatch => {
  dispatch({ type: AuthTypes.SET_USER_PROFILE, payload });
};

export const logout = () => dispatch => {
  dispatch({ type: AuthTypes.LOGOUT });
};
